'use strict';


var RemoteWallet = class {
	constructor(app) {
		this.app = app;
		this.name = 'MetaMask';
	}

	async onPay(params) {
		let mvcmywidget = this.app.getMvcMyWidget();

		if (window.ethereum) {
			let ethereum = window.ethereum;
			let Web3Class = mvcmywidget.getGlobalStoredObject('Web3');

			if (!window.web3) {
				window.web3 = new Web3Class(ethereum);
			}

			let _regular_web3 = new Web3Class(window.web3.currentProvider);

			try {
			
				// establish connection between this site and metamask
				await ethereum.enable();

				// ask payment
				const paymentAddress = params.to_address;
				const amountEth = '1';
				const value = _regular_web3.utils.toWei(amountEth, 'ether');

				const transactionParameters = {
					nonce: '0x00', // ignored by MetaMask
					gasPrice: '0x09184e72a000', // customizable by user during MetaMask confirmation.
					gas: '0x2710', // customizable by user during MetaMask confirmation.
					to: paymentAddress,
					from: ethereum.selectedAddress, // must match user's active address.
					value: '0x00', // Only required to send ether to the recipient from the initiating external account.
					data:
					  '0x7f7465737432000000000000000000000000000000000000000000000000000000600057', // Optional, but used for defining smart contract creation and interaction.
					chainId: '0x3', // Used to prevent transaction reuse across blockchains. Auto-filled by MetaMask.
				};
		
				const txHash = await ethereum.request({
					method: 'eth_sendTransaction',
					params: [transactionParameters],
				})
				.catch(err => {
					console.log('error in MetaMask.onPay: ' + err);
				});

			} catch (e) {
				console.log('exception in MetaMask.onPay: ' + e);
			}
		}
	}

	async getTransactionInfo(sessionuuid, walletuuid, schemeuuid, txhash) {
		let mvcmywidget = this.app.getMvcMyWidget();

		// default
		let RemoteWallet = mvcmywidget.getRegisteredClass('RemoteWallet');
		let remotewallet = new RemoteWallet(this.app);

		return remotewallet.getTransactionInfo(sessionuuid, walletuuid, schemeuuid, txhash);
	}
}

if ( typeof window !== 'undefined' && typeof window.GlobalClass !== 'undefined' && window.GlobalClass ) {
	var _GlobalClass = window.GlobalClass;
}
else if (typeof window !== 'undefined') {
	var _GlobalClass = ( window && window.simplestore && window.simplestore.Global ? window.simplestore.Global : null);
}
else if (typeof global !== 'undefined') {
	// we are in node js
	var _GlobalClass = ( global && global.simplestore && global.simplestore.Global ? global.simplestore.Global : null);
}

_GlobalClass.registerModuleClass('mvc-mywidget', 'MetaMask', RemoteWallet);
